module.exports = __webpack_public_path__ + "img/ireland _icc.4b6d7e47.png";